import { AccountType, TrimmedCurrentAccountFragment } from '~/generated/graphql'

export function renderTitleText(path: string, account?: TrimmedCurrentAccountFragment) {
  return account?.type === AccountType.Personal
    ? titles[path] || path
    : account?.type === AccountType.Brand
      ? titlesBrand[path] || path
      : titlesAgency[path] || path
}
export function renderButtonText(path: string) {
  return buttons[path] || path
}

const onboardingPhrases = {
  signinTitle: 'Welcome to Dome\nthe producer in your pocket',
  registrationTitle: "Let's get your new profile setup",
  registrationTitle2: 'Hi, tell us about yourself',
  registrationButton1: 'PROFESSIONAL DETAILS',
  registrationButton2: 'SETUP ACCOUNT',
  registrationButton3: 'ADD FOLIO',
  folioTitle: 'Add folio images to showcase\nyour best work',
  folioTitleBrand: 'Add folio images to showcase\nyour brand',
  folioTitleAgency: 'Add folio images to showcase\nyour agencies work',
  folioButton: 'EXPLORE DOME',
  choosePlan: 'Choose your subscription level',
  lightOnboardingTitle: 'Let us know your name',
  lightOnboardingButton: 'GO TO PROJECT',
}

const titles: Record<string, string> = {
  '/onboarding/individual': onboardingPhrases.registrationTitle,
  '/onboarding/individual/light': onboardingPhrases.registrationTitle,
  '/onboarding/business': onboardingPhrases.registrationTitle,
  //'/signin': onboardingPhrases.signinTitle,
  '/onboarding/folio': onboardingPhrases.folioTitle,
  '/onboarding/profile': onboardingPhrases.registrationTitle2,
  '/onboarding/plan': onboardingPhrases.choosePlan,
}

const titlesBrand: Record<string, string> = {
  '/onboarding/individual': onboardingPhrases.registrationTitle,
  '/onboarding/business': onboardingPhrases.registrationTitle,
  //'/signin': onboardingPhrases.signinTitle,
  '/onboarding/folio': onboardingPhrases.folioTitleBrand,
  '/onboarding/profile': onboardingPhrases.registrationTitle2,
  '/onboarding/plan': onboardingPhrases.choosePlan,
}

const titlesAgency: Record<string, string> = {
  '/onboarding/individual': onboardingPhrases.registrationTitle,
  '/onboarding/business': onboardingPhrases.registrationTitle,
  //'/signin': onboardingPhrases.signinTitle,
  '/onboarding/folio': onboardingPhrases.folioTitleAgency,
  '/onboarding/profile': onboardingPhrases.registrationTitle2,
  '/onboarding/plan': onboardingPhrases.choosePlan,
}

const buttons: Record<string, string> = {
  '/onboarding/folio': onboardingPhrases.folioButton,
  '/onboarding/individual': onboardingPhrases.registrationButton1,
  '/onboarding/individual/light': onboardingPhrases.folioButton,
  // '/onboarding/business': onboardingPhrases.registrationButton2,
  // '/onboarding/profile': onboardingPhrases.registrationButton2,
  // '/onboarding/plan': onboardingPhrases.registrationButton3,
  '/onboarding/business': onboardingPhrases.registrationButton3,
  '/onboarding/profile': onboardingPhrases.registrationButton3,
}
